import styled from 'styled-components';
import { Flex } from '../../layout/Flex';
import { Typography } from '../../typography/Typography';

export const Wrapper = styled(Flex).withConfig({ displayName: 'Suggest' }).attrs({
    zIndex: 9999,
    minWidth: 250,
    position: 'relative',
    borderRadius: 2,
    background: 'var(--background-primary)',
    boxShadow: '0px 0px 4px 0px var(--control-primary-blur-background)',
    overflow: 'hidden',
})``;

export const Item = styled(Typography).withConfig({ displayName: 'SuggestItem' }).attrs({
    p: 2,
    width: '100%',
    cursor: 'pointer',
    outline: 'none',
    '-webkit-user-select': 'none',
    'user-select': 'none',
    '-webkit-tap-highlight-color': 'transparent',
    transition: 'transform 0.1s ease-out, background-color 0.1s ease-out',
})`
    &:hover {
        background-color: var(--background-secondary);
    }
`;
